import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
} from "react";

const LoadingContext = createContext(null);

const MINIMUM_LOAD_TIME = 300; // Show spinner for at least 300ms

export const LoadingProvider = ({ children }) => {
  const [requestCount, setRequestCount] = useState(0);
  const [isMinimumTimeElapsed, setIsMinimumTimeElapsed] = useState(true);
  const loadingTimeoutRef = useRef(null);

  const incrementRequestCount = useCallback(() => {
    setRequestCount((prev) => {
      const newCount = prev + 1;
      if (newCount === 1) {
        // First request starting - reset timer
        setIsMinimumTimeElapsed(false);
        if (loadingTimeoutRef.current) {
          clearTimeout(loadingTimeoutRef.current);
        }
        loadingTimeoutRef.current = setTimeout(() => {
          setIsMinimumTimeElapsed(true);
        }, MINIMUM_LOAD_TIME);
      }
      return newCount;
    });
  }, []);

  const decrementRequestCount = useCallback(() => {
    setRequestCount((prev) => Math.max(0, prev - 1));
  }, []);

  const isLoading = requestCount > 0 || !isMinimumTimeElapsed;

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        incrementRequestCount,
        decrementRequestCount,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
};
